/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.15.0
 */

import { EBadgeStatus } from '../../components/common/Badge/BadgeStatus';
import { EOrderIdStatus } from './types';

export const mapOrderIdStatusToBadgeType: { [key in EOrderIdStatus]: EBadgeStatus } = {
    [EOrderIdStatus.confirm]: EBadgeStatus.active,
    [EOrderIdStatus.confirmedPartially]: EBadgeStatus.changed,
    [EOrderIdStatus.error]: EBadgeStatus.blocked,
    [EOrderIdStatus.processing]: EBadgeStatus.changed,
    [EOrderIdStatus.rejected]: EBadgeStatus.blocked,
    [EOrderIdStatus.reorder]: EBadgeStatus.active,
    [EOrderIdStatus.success]: EBadgeStatus.active,
    [EOrderIdStatus.successPartially]: EBadgeStatus.changed,
    [EOrderIdStatus.waitingConfirm]: EBadgeStatus.changed,
    [EOrderIdStatus.waitingProcessing]: EBadgeStatus.changed,
};
